module.exports = __webpack_public_path__ + "static/media/personal-drinks-3.958fb3b9.jpg";